import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['input', 'result']

  connect() {
  }

  calc() {
    let result = 0.0
    for(let input of this.inputTargets) {
      if(input.value) result += parseFloat(input.value.replace(',', ''))
    }
    this.resultTarget.innerHTML = result.toFixed(2).toLocaleString('en-US', { style: 'decimal' })
  }
}
